import featureList from 'feature.json';

type FeatureName = keyof typeof featureList;

export default class Feature {
	public static featureList: Record<FeatureName, boolean> = featureList;

	public static isFeatureEnabled = (name: FeatureName) => Boolean(Feature.featureList[name]);
}
